module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "divPDF"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.pdfContent) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5697e94a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PDF.vue
// module id = 891
// module chunks = 2